module.exports = __webpack_public_path__ + "img/BAU Seniors_3.379d62b8.jpg";